import { cn } from '@/lib/utils';

interface Stat {
  value: string | number;
  label?: string;
  icon?: React.ReactNode;
}

interface TabStatsLineProps {
  stats: Stat[];
  className?: string;
}

export const TabStatsLine = ({ stats, className }: TabStatsLineProps) => {
  if (stats.length === 0) return null;

  return (
    <div className={cn(
      "flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-foreground mt-4",
      className
    )}>
      {stats.map((stat, index) => (
        <span key={index} className="flex items-center gap-1">
          {stat.icon}
          <span>
            {stat.label ? `${stat.value} ${stat.label}` : stat.value}
          </span>
          {index < stats.length - 1 && (
            <span className="text-muted-foreground/50 ml-1">·</span>
          )}
        </span>
      ))}
    </div>
  );
};
